import { h, Fragment, Component } from "preact";
import { observer } from "mobx-react";
import { RecommendationProfileTracker, RecommendationResultTracker } from '@searchspring/snap-preact-components';

import { Result } from '../../Result/Result'

import { ArrowUp } from "../../Icons/ArrowUp";
import { ArrowDown } from "../../Icons/ArrowDown";

import Slider from "react-slick";

import "../../../slick-carousel/slick/slick.css";
import "../../../slick-carousel/slick/slick-theme.css";

// CSS
import './recs.css'

@observer
export class Recs extends Component {
  constructor(props) {
    super();

    const controller = props.controller;

    if (!controller.store.profile) {
      controller.init();
      controller.search();
    }

    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);

    this.updateSlidesAnchorsTabIndexes = () => {
      document.querySelectorAll('.slick-slide[aria-hidden="true"] a').forEach(e => e.setAttribute("tabIndex", "-1"));  
      document.querySelectorAll('.slick-slide[aria-hidden="false"] a').forEach(e => e.removeAttribute("tabIndex"));  
    }
  }

  componentDidMount() {
    const slickDots = document.querySelectorAll('.cql-carousel-recommendation--contain .slick-dots li button'); 
    slickDots.forEach(button => button.ariaLabel = "Go to Slide " + button.innerHTML);     
  }

  next() {
    this.slider.slickNext();
  }
  previous() {
    this.slider.slickPrev();
  }

  componentDidMount() {
    this.updateSlidesAnchorsTabIndexes();
  }

  render() {
    const controller = this.props.controller;
    const type = controller.context?.options?.type;
    const isCartDrawer = type === 'cart-drawer';
    const store = controller?.store;
    const params = store.profile?.display?.templateParameters;
    const config = store.config;

    const title = params?.title || null;
    const tag = config?.tag || 'unknown';
    let maxProductsToShow = params?.maxProductsToShow || 12;
    let { hideRatings, hideSwatches, hideMessages } = false;
    let hideTitle = true;

    switch (tag) {
			case 'cross-sell':
				hideSwatches = true;
				hideMessages = true;
				break;
		}    

    const settings = {
			arrows: false,
			dots: true,
			infinite: false,
			appendDots: dots => (
        <div class="cql-carousel--navigation cql-carousel--navigation-dots">
          <button class="glider-prev cql-carousel--arrow cql-carousel--prev slick-arrow" aria-label="Previous Slide"  onClick={this.previous}>
            <ArrowUp/>
          </button>
          <button class="glider-next cql-carousel--arrow cql-carousel--next slick-arrow" aria-label="Next Slide" onClick={this.next} >
            <ArrowDown/>
          </button>
          <ul class="slick-dots">{dots}</ul>
        </div>
			),
			slidesToShow: isCartDrawer ? 1.33 : 4,
			slidesToScroll: isCartDrawer ? 1 : 4,
			responsive: [
				{
					breakpoint: 749,
					settings: {
						slidesToShow: isCartDrawer ? 1.33 : 2,
						slidesToScroll: isCartDrawer ? 1 : 2,
					},
				},
				{
					breakpoint: 989,
					settings: {
						slidesToShow: isCartDrawer ? 1.33 : 3,
						slidesToScroll: isCartDrawer ? 1 : 3,
					},
				},
			],
			afterChange: () => {
				const dotContainer = document.getElementById(`cql-carousel-recommendation-${controller.id}`).querySelector('ul.slick-dots');
				const prevArrow = document.getElementById(`cql-carousel-recommendation-${controller.id}`).querySelector('.glider-prev');
				const nextArrow = document.getElementById(`cql-carousel-recommendation-${controller.id}`).querySelector('.glider-next');
				const pageCount = dotContainer.childElementCount;
				const activeItem = dotContainer.querySelector('.slick-active');
				const activeIndex = Array.prototype.indexOf.call(dotContainer.children, activeItem) + 1;
        this.updateSlidesAnchorsTabIndexes(); 

				if(pageCount === 1){
          prevArrow.disabled = true;
          nextArrow.disabled = true;
        } else if(activeIndex >= pageCount){
          prevArrow.disabled = false;
          nextArrow.disabled = true;
        } else if (activeIndex === 1) {
          prevArrow.disabled = true;
          nextArrow.disabled = false;
        } else {
          prevArrow.disabled = false;
          nextArrow.disabled = false;
        }
      }
    }

    return (
      <div id={`cql-carousel-recommendation-${controller.id}`} class="ss__recs cql-carousel--contain cql-carousel-recommendation--contain container">
        {!hideTitle && <h3 class="cql-carousel-recommendation--title h1">{title}</h3>}
        <RecommendationProfileTracker controller={controller}>
        <Slider class="glider cql-carousel cql-carousel-recommendation" ref={c => (this.slider = c)} {...settings}>
          {store.results.map((result, i) => {
            return i < maxProductsToShow ? (
              <RecommendationResultTracker controller={controller} result={result}>
                <Result
                  isRecommendations
                  result={result}
                  hideRatings={hideRatings}
                  hideSwatches={hideSwatches}
                  hideMessages={hideMessages}
                  hidePricing
                />
              </RecommendationResultTracker>
            ) : null;
          })}
        </Slider>
        </RecommendationProfileTracker>
      </div>
    );
  }
}
